<template>
  <section class='section'>
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <h1>Inventario: {{total}}</h1>
        </div>
      </div>
      <div style="display: flex; flex-wrap: wrap; gap: 10px; padding: 10px 0; justify-content: end;">
        <div class="level-item">
          <button
            class="button"
            type="button"
            :class="{ 'is-loading': isLoading }"
            @click="getCsvDownload"
          >
            Descargar
          </button>
        </div>
        <div class="level-item">
          <div class="control">
            <input class="input" style="max-width: 150px;" v-model="search" @input="searchProducts" placeholder="Buscar por producto...">
          </div>
        </div>
        <div class="level-item">
          <div class="select is-fullwidth" @change="filterProducts">
            <select class="select" v-model="currentFilters.filter">
              <option value="0">Todos</option>
              <option value="1">Pendiente</option>
              <option value="2">Activo</option>
              <option value="3">Vendido</option>
              <option value="4">Eliminado</option>
            </select>
          </div>
        </div>
        <div class="level-item">
          <button @click="toggleDatePicker" v-if="!showDatePicker" class="button">
            Filtrar por fecha
          </button>
          <div v-else style="max-width: 150px; overflow: hidden;">
            <v-date-picker
              mode="range"
              v-model="date"
              :max-date="today"
              @input="onDateChange"
            />
          </div>
          <button @click="resetDate" v-if="showDatePicker" class="button" style="padding: 4px;">
            <span class="material-icons">
              restart_alt
            </span>
          </button>
        </div>

        <div class="level-item">
          <button
            class="button is-info"
            @click="openBulkModal"
          >
            Carga Masiva
          </button>
        </div>

        <div class="level-item">
          <router-link
            class="button button-givu"
            :to="{name: 'producto'}"
          >
            Agregar
          </router-link>
        </div>
      </div>
    </nav>

    <div class="modal" :class="{ 'is-active': bulkModalActive }">
      <div class="modal-background" @click="closeBulkModal"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Importar Productos (.xlsx)</p>
          <button class="delete" aria-label="close" @click="closeBulkModal"></button>
        </header>
        <section class="modal-card-body">

          <div v-if="!bulkResults">
            <div class="field">
              <label class="label">Archivo Excel</label>
              <div class="control">
                <input class="input" type="file" accept=".xlsx" @change="onExcelSelected">
              </div>
              <p class="help">Selecciona el archivo con la estructura de productos.</p>
            </div>
          </div>

          <div v-else>
            <div v-if="bulkResults.success">
              <div class="notification is-light is-success">
                <p><strong>Procesamiento finalizado</strong></p>
                <div class="columns is-mobile mt-2">
                  <div class="column has-text-centered">
                    <p class="heading">Total</p>
                    <p class="title is-5">{{ bulkResults.data.total }}</p>
                  </div>
                  <div class="column has-text-centered">
                    <p class="heading">Éxito</p>
                    <p class="title is-5">{{ bulkResults.data.success }}</p>
                  </div>
                  <div class="column has-text-centered">
                    <p class="heading">Errores</p>
                    <p class="title is-5 has-text-danger">{{ bulkResults.data.failed }}</p>
                  </div>
                </div>
              </div>

              <div v-if="bulkResults.data.errors.length > 0" class="mt-4">
                <p class="subtitle is-6">Detalle de errores:</p>
                <div style="max-height: 250px; overflow-y: auto;">
                  <table class="table is-fullwidth is-striped is-narrow">
                    <thead>
                      <tr>
                        <th>Fila</th>
                        <th>Producto</th>
                        <th>Error</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(err, idx) in bulkResults.data.errors" :key="idx">
                        <td>{{ err.row }}</td>
                        <td>{{ err.product }}</td>
                        <td class="has-text-danger is-size-7">{{ err.error }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div v-else class="notification is-danger">
              <p><strong>Error en la carga:</strong></p>
              <p>{{ bulkResults.error }}</p>
            </div>
          </div>

        </section>
        <footer class="modal-card-foot">
          <button
            v-if="!bulkResults"
            class="button is-success"
            :class="{'is-loading': isUploadingBulk}"
            @click="submitBulkUpload"
            :disabled="!selectedExcel"
          >
            Subir Archivos
          </button>
          <button class="button" @click="closeBulkModal">{{ bulkResults ? 'Cerrar' : 'Cancelar' }}</button>
        </footer>
      </div>
    </div>

    <div class="columns is-multiline">
      <div class="column is-12">
        <base-table
          :columns="computedColumnsData"
          :data="productList"
          :loading="loading"
          @sort="handleSort"
        >
        </base-table>
      </div>
    </div>
    <base-pagination
      class="is-medium"
      :page="currentFilters.page"
      :pages="parseInt(pages)"
      :action="paginator"
      :loading="loading"
    />
  </section>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import mixin from '../../mixin/validateDate'
const PREOWNED = 2

export default {
  mixins: [mixin],
  name: 'Inventory',
  components: {
    BaseTable: () => import('@/components/Table'),
    BasePagination: () => import('@/components/BasePagination')
  },
  data () {
    return {
      bulkModalActive: false,
      isUploadingBulk: false,
      selectedExcel: null,
      bulkResults: null,
      addUserModal: false,
      modalEditAdmin: false,
      pages: '',
      total: 0,
      search: '',
      loading: false,
      isLoading: false,
      productList: [],
      date: {},
      today: moment().add(1, 'days').format('YYYY-MM-DD'),
      showDatePicker: false,
      columnsData: [
        { id: 'productId', header: '#', class: 'column-mobile' },
        { id: 'name',
          header: 'Nombre del Producto',
          class: 'column-mobile',
          type: 'link',
          link: true,
          html: true,
          accessor: (row) => `<div style="display:flex; align-items: center; font-weight: ${!row.openedadmin ? '800' : '200'};">
            <div
              data-tooltip="${row.statusId ? row.status : ''}"
              class="has-tooltip-top"
              style="width: 8px; height: 8px; border-radius: 50%; margin-right: 5px; background-color: ${row.statusId === 4 ? 'hsl(348, 100%, 61%)' : ''}${row.statusId === 1 ? 'hsl(204, 86%, 53%)' : ''}${row.statusId === 2 ? 'hsl(141, 71%, 48%)' : ''}${row.statusId === 5 ? '#FFC107' : ''}"
            >
            </div>
            <div
              data-tooltip="${row.visible ? 'El producto está visible' : 'El producto se ha ocultado'}"
            >
              ${row.visible ? '👁️' : '<span style="text-decoration:line-through;filter: gray;-webkit-filter: grayscale(1);filter: grayscale(1);">👁️</span>'}
            </div>
            ${row.name}</div>`,
          route: (row) => `inventario/detalle/${row.productId}`
        },
        {
          id: 'nameuser',
          header: 'Usuario',
          class: 'column-mobile',
          type: 'link',
          link: true,
          route: (row) => `usuarios/detalle/${row.userId}`
        },
        {
          id: 'price',
          header: this.priceHeader,
          class: 'column-mobile',
          sortable: true,
          clickEvent: this.toggleSortOrder,
          accessor: (row) => {
            const priceDisplay = row.price ? `${parseFloat(row.price).toLocaleString('es-MX', {
              style: 'currency',
              currency: 'MXN',
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            })}` : 'N/A'
            return priceDisplay
          }
        },
        {
          id: 'stock',
          header: this.stockHeader,
          class: 'column-mobile',
          sortable: true,
          clickEvent: this.toggleSortOrder,
          accessor: (row) => row.stock
        },
        {
          id: 'status',
          header: 'Estado',
          class: 'column-mobile',
          accessor: (row) => row.status
        },
        {
          id: 'rejected_message',
          header: 'Motivo de Rechazo',
          class: 'column-mobile has-break-word',
          accessor: (row) => row.rejected_message
        },
        {
          id: 'view_by_administrator',
          header: 'Visto por el admin',
          class: 'column-mobile',
          accessor: (row) => row.adminName
        },
        {
          id: 'condition',
          header: 'Condición',
          class: 'column-desktop',
          accessor: (row) => row.condition === PREOWNED ? 'Seminuevo' : 'Nuevo'
        },
        {
          id: 'createdAt',
          header: 'Fecha y hora de creación',
          class: 'column-mobile',
          accessor: (row) => `${this.formatDateTimestamp(row.createdAt)} ${this.formatDateTimestampHour(row.createdAt)}`
        },
        {
          id: 'updatedAt',
          header: 'Fecha y hora de actualización',
          class: 'column-mobile',
          accessor: (row) => `${this.formatDateTimestamp(row.updatedAt)} ${this.formatDateTimestampHour(row.updatedAt)}`
        }
      ],
      currentFilters: {
        page: 1,
        filter: 0,
        search: '',
        sortKey: 'price',
        sortOrder: 'asc',
        username: '',
        startDate: '',
        endDate: '',
        onlyGiver: true
      }
    }
  },
  watch: {
    '$route.query': {
      immediate: true,
      handler (query) {
        this.setFiltersFromQuery(query)
        this.fetchProducts()
      }
    }
  },
  computed: {
    priceHeader () {
      return `Precio ${this.currentFilters.sortKey === 'price' ? (this.currentFilters.sortOrder === 'asc' ? '↑' : '↓') : '↑↓'}`
    },
    computedColumnsData () {
      return this.columnsData.map(column => {
        if (column.id === 'price') {
          return {
            ...column,
            header: `Precio ${this.currentFilters.sortKey === 'price' ? this.sortIcon : ''}`
          }
        }
        if (column.id === 'stock') {
          return {
            ...column,
            header: `Stock ${this.currentFilters.sortKey === 'stock' ? this.sortIcon : ''}`
          }
        }
        return column
      })
    },
    sortIcon () {
      return this.currentFilters.sortOrder === 'asc' ? '↑' : '↓'
    }
  },
  methods: {
    ...mapActions(['getProducts', 'csvDownloadProducts', 'addTemporalNotification', 'bulkUploadProducts']),

    openBulkModal () {
      this.bulkModalActive = true
      this.bulkResults = null
    },
    closeBulkModal () {
      this.bulkModalActive = false
      if (this.bulkResults && this.bulkResults.success) {
        this.fetchProducts()
      }
      this.selectedExcel = null
      this.bulkResults = null
    },
    onExcelSelected (event) {
      this.selectedExcel = event.target.files[0]
    },
    async submitBulkUpload () {
      if (!this.selectedExcel) return

      this.isUploadingBulk = true

      const response = await this.bulkUploadProducts({
        excelFile: this.selectedExcel
      })

      this.bulkResults = response

      this.isUploadingBulk = false
    },

    paginator (newPage) {
      this.updateFilters({ page: newPage })
    },
    fetchProducts () {
      this.loading = true
      this.getProducts(this.currentFilters)
        .then(resp => {
          this.productList = resp.payload
          this.pages = resp.totalPages
          this.loading = false
          this.total = resp.total
        })
        .catch(error => {
          this.addTemporalNotification({ type: 'danger', message: error.message })
          this.loading = false
        })
    },
    setFiltersFromQuery (query) {
      this.currentFilters.page = parseInt(query.page, 10) || 1
      this.currentFilters.filter = parseInt(query.filter, 10) || 0
      this.currentFilters.search = query.search || ''
      this.currentFilters.sortKey = query.sortKey || 'product.updatedAt'
      this.currentFilters.sortOrder = query.sortOrder || 'desc'
      this.currentFilters.startDate = query.startDate || ''
      this.currentFilters.endDate = query.endDate || ''
      this.fetchProducts()
    },
    updateFilters (newFilters) {
      this.currentFilters = { ...this.currentFilters, ...newFilters }
      this.$router.push({ name: 'inventario', query: this.currentFilters }).catch(err => {
        if (err.name !== 'NavigationDuplicated') console.error(err)
      })
    },
    handleSort (sortKey) {
      const newSortOrder = this.currentFilters.sortKey === sortKey && this.currentFilters.sortOrder === 'asc' ? 'desc' : 'asc'
      this.updateFilters({ sortKey, sortOrder: newSortOrder })
    },
    toggleSortOrder () {
      const newSortOrder = this.currentFilters.sortOrder === 'asc' ? 'desc' : 'asc'
      this.updateFilters({ sortOrder: newSortOrder })
    },
    searchProducts ({ target }) {
      const search = target.value
      if (search.length >= 3 || search.length === 0) {
        this.updateFilters({ search, page: 1 })
      }
    },
    filterProducts ({ target }) {
      const filter = parseInt(target.value, 10) || 0
      this.updateFilters({ filter, page: 1 })
    },
    getCsvDownload () {
      this.isLoading = true
      this.csvDownloadProducts({ ...this.currentFilters })
        .then(resp => {
          if (resp) {
            const blob = new Blob([resp], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.setAttribute('download', 'productos.xlsx')
            link.click()
            URL.revokeObjectURL(link.href)
          } else {
            this.addTemporalNotification({ type: 'danger', message: 'Error en la descarga' })
          }
          this.isLoading = false
        })
    },
    onDateChange (newDate) {
      if (!newDate) return
      this.currentFilters.startDate = moment(newDate.start).format('YYYY-MM-DD')
      this.currentFilters.endDate = moment(newDate.end).format('YYYY-MM-DD')
      this.updateFilters({ page: 1 })
    },
    toggleDatePicker () {
      this.showDatePicker = !this.showDatePicker
    },
    resetDate () {
      this.date = {}
      this.showDatePicker = false
      this.currentFilters.startDate = ''
      this.currentFilters.endDate = ''
      this.updateFilters({ page: 1 })
    }
  },
  beforeMount () {
    this.setFiltersFromQuery(this.$route.query)
  }
}
</script>

<style scoped>
  .section {
    width: 100%;
    padding: 0 20px 0 20px;
  }
  .icon-action {
    cursor: pointer;
    color: #039DA1;
  }
</style>

<style>
  .has-break-word {
    word-break: break-word;
  }
  .level-right {
    width: fit-content;
    flex-flow: wrap;
    row-gap: 10px;
  }
</style>
